import http from "@/services/http";

export function createOpeningBalance(payload) {
  return http.post("/opening-balances", payload);
}

export function updateOpeningBalance(id, payload) {
  return http.put(`/opening-balances/${id}`, payload);
}

export function getOpeningBalanceForParticipant(participant) {
  if (!participant || !participant.id) {
    return Promise.reject(new Error("Participant ID is required"));
  }

  if (participant.participant_type === "beneficiary") {
    return http.get(`/opening-balances/beneficiaries/${participant.id}`);
  }

  return http.get(`/opening-balances/user/${participant.id}`);
}